const resolveThemeColor = (value, theme) => {
    if (!value) return value;

    if (typeof value !== 'string') return value;

    if (value.startsWith('#') || value.startsWith('rgb')) return value;

    const token = value.startsWith('theme.')
        ? value.replace(/^theme\./, '')
        : value;
    const parts = token.split('.');
    let current = theme;
    for (const p of parts) {
        if (current && Object.prototype.hasOwnProperty.call(current, p)) {
            current = current[p];
        } else {
            current = undefined;
            break;
        }
    }

    return typeof current === 'string' ? current : value;
};

export default resolveThemeColor;
